import React from 'react'
import { HiArrowRight } from 'react-icons/hi'
import { FaGithub, FaLinkedin } from 'react-icons/fa'
import { useInView } from '../useInView'

const Contact = () => {
  const [ref, isInView] = useInView()

  return (
    <section id="contact" className="py-20 md:py-32 relative" ref={ref}>
      <div className="max-w-3xl mx-auto px-6 sm:px-8 text-center">
        <span className={`inline-block font-mono text-lime text-sm tracking-wider mb-4 transition-all duration-700 ${
          isInView ? 'opacity-100' : 'opacity-0'
        }`}>
          05
        </span>

        <h2 className={`text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-display font-extrabold text-cream mb-6 sm:mb-8 transition-all duration-700 ${
          isInView ? 'opacity-100 translate-y-0 delay-100' : 'opacity-0 translate-y-8'
        }`}>
          Let's Talk<span className="text-lime">.</span>
        </h2>

        <p className={`text-cream-dim text-base sm:text-lg md:text-xl mb-10 sm:mb-14 leading-relaxed max-w-xl mx-auto font-light transition-all duration-700 ${
          isInView ? 'opacity-100 translate-y-0 delay-200' : 'opacity-0 translate-y-8'
        }`}>
          I'm currently open to new opportunities and collaborations.
          Whether you have a question, a project idea, or just want to
          connect — feel free to reach out.
        </p>

        <div className={`transition-all duration-700 ${
          isInView ? 'opacity-100 translate-y-0 delay-300' : 'opacity-0 translate-y-8'
        }`}>
          <a
            href="mailto:sakariaahmed.code@gmail.com"
            className="group inline-flex items-center gap-3 px-8 py-4 sm:px-10 sm:py-5 bg-lime text-dark font-medium text-base sm:text-lg rounded-full hover:shadow-[0_0_50px_rgba(201,251,53,0.25)] transition-all duration-500 hover:scale-105"
          >
            Say Hello
            <HiArrowRight className="transition-transform group-hover:translate-x-2" />
          </a>
        </div>

        <div className={`mt-14 sm:mt-16 flex justify-center gap-5 transition-all duration-700 ${
          isInView ? 'opacity-100 delay-[400ms]' : 'opacity-0'
        }`}>
          <a
            href="https://github.com/SakariaAhmed"
            target="_blank"
            rel="noopener noreferrer"
            className="p-3 rounded-full border border-edge text-cream-muted hover:text-lime hover:border-lime/40 transition-all duration-300 hover:scale-110"
            aria-label="GitHub"
          >
            <FaGithub className="text-xl sm:text-2xl" />
          </a>
          <a
            href="https://www.linkedin.com/in/sakaria-ahmed-02a801184/"
            target="_blank"
            rel="noopener noreferrer"
            className="p-3 rounded-full border border-edge text-cream-muted hover:text-lime hover:border-lime/40 transition-all duration-300 hover:scale-110"
            aria-label="LinkedIn"
          >
            <FaLinkedin className="text-xl sm:text-2xl" />
          </a>
        </div>
      </div>

      <footer className="mt-20 sm:mt-28 text-center pb-6 sm:pb-8">
        <div className="flex items-center justify-center gap-3 mb-4">
          <div className="w-8 h-px bg-edge" />
          <span className="text-lime text-xs">&#9670;</span>
          <div className="w-8 h-px bg-edge" />
        </div>
        <p className="text-cream-muted text-sm">
          Designed & Built by{' '}
          <a
            href="https://www.linkedin.com/in/sakaria-ahmed-02a801184/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-cream-dim hover:text-lime transition-colors"
          >
            Sakaria Ahmed
          </a>
        </p>
      </footer>
    </section>
  )
}

export default Contact
